import { RecurringUserTaskType } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';

export interface IRecurringUserTaskCreateProps {
  type: RecurringUserTaskType;

  corporationId: number;

  effectiveStartDate?: string;

  effectiveEndDate?: string;

  dueDate?: string;
}

export async function createRecurringUserTask(
  data: IRecurringUserTaskCreateProps,
  nextAuthToken: string
): Promise<Response> {
  const res = await fetcher(
    'recurringUserTasks',
    { method: 'POST', body: data },
    nextAuthToken
  );
  return res;
}
